import { apiAxios } from '@/lib/apiAxios';
const BASE = '/internal/cron';
export const fetchCronJobs = async () => apiAxios.get(`${BASE}/jobs`).then((r) => r.data);
export const fetchSchedules = async () => apiAxios.get(`${BASE}/schedules`).then((r) => r.data);
export const createSchedule = async (data) => apiAxios.post(`${BASE}/schedules`, data).then((r) => r.data);
export const updateSchedule = async ({ id, data, }) => apiAxios.patch(`${BASE}/schedules/${id}`, data).then((r) => r.data);
export const deleteSchedule = async (id) => apiAxios.delete(`${BASE}/schedules/${id}`).then((r) => r.data);
export const runScheduleNow = async (id) => apiAxios.post(`${BASE}/schedules/${id}/run`, {}).then((r) => r.data);
export const fetchScheduleRuns = async (command, limit = 20) => apiAxios
    .get(`${BASE}/runs`, { params: { command, limit } })
    .then((r) => r.data);
